import { render, staticRenderFns } from "./TariffTourismItem.vue?vue&type=template&id=11b8b5a6&scoped=true&"
import script from "./TariffTourismItem.vue?vue&type=script&lang=ts&"
export * from "./TariffTourismItem.vue?vue&type=script&lang=ts&"
import style0 from "./TariffTourismItem.vue?vue&type=style&index=0&id=11b8b5a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b8b5a6",
  null
  
)

export default component.exports